export type AbsoluteDateRange = {
  fromDate: string;
  toDate: string;
};

export enum SortBy {
  Value = `value`,
  Column = `column`,
  Label = `label`,
}

export enum SortOrder {
  Ascending = `asc`,
  Descending = `desc`,
}

export enum InsightsChartType {
  Bar = `bar`,
  Line = `line`,
  Pie = `pie`,
  Table = `table`,
}

export interface FlatSortingOptions {
  sortBy: SortBy.Value | SortBy.Label;
  sortOrder: SortOrder;
}

export interface SeriesSortingOptions {
  colSortAttrs: FlatSortingOptions[];
  sortBy: SortBy;
  sortOrder?: SortOrder;
}

export interface SortConfig {
  [InsightsChartType.Bar]: SeriesSortingOptions;
  [InsightsChartType.Table]: SeriesSortingOptions;
  [InsightsChartType.Line]: FlatSortingOptions;
}
